
import React, { useState, useContext, useEffect } from 'react'
import {
	Button,
	Card,
	CardBody,
	CardFooter,
	CardGroup,
	CardHeader,
	Col,
	Form,
	FormGroup,
	Input,
	Label,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Row
} from 'reactstrap'
import { useTranslation } from 'react-i18next'
import { SpinnerComponent } from 'react-element-spinner'

import { trigger } from '../../events/customEvents'
import AuctionsService from '../../services/AuctionsService'
import SiteService from '../../services/SiteService'
import { SessionContext } from '../../contexts/SessionProvider'
import Enumeration from '../../enumeration'
import asDescribedImage from '../../assets/images/brand/as-described.png'
import conditionReportImage from '../../assets/images/brand/condition-report.png'
import firstRunImage from '../../assets/images/brand/first-run.png'

const PlaceMemberBuyNowModal = ({ showMemberBuyNowModal, auctionListItem }) =>
{
	const [isModalBusy, setIsModalBusy] = useState(false)
	const { t } = useTranslation()
	const sessionContext = useContext(SessionContext)
	const [openConfirmBuyNow, setOpenConfirmBuyNow] = useState(false)

	useEffect(() =>
	{

	}, [])

	const handleOnOpened = () =>
	{

	}

	const handleCancelModal = (e) =>
	{
        e.preventDefault()
		trigger('placeMemberBuyNowModalClosed', { buyNowPlaced: false, reason: 'Cancelled' })
	}

	const handlePlaceBuyNow = (e) =>
	{
		e.preventDefault()
		e.stopPropagation()

		setOpenConfirmBuyNow(false)

		setIsModalBusy(true)
		AuctionsService
			.addMemberBuyNow(auctionListItem.auctionTier.auctionTierMemberId, auctionListItem.auctionVehicleId, sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsModalBusy(false)
				sessionContext.updateSession(result.data.loginSession)

				trigger('raiseNotification', { title: 'Buy Now Submitted', message: 'The buy now offer was placed.', type: 'success', duration: 5 })
				trigger('placeMemberBuyNowModalClosed', { buyNowPlaced: true, reason: '' })
			})
			.catch((error) =>
			{
				setIsModalBusy(false)
				SiteService.displayApiError(error)
			})
	}
	
	const buyNowPriceDisplay = () =>
	{
		if (auctionListItem.auctionTier)
		{
			let listItemPrice = auctionListItem.buyNowPrice
			switch (auctionListItem.auctionTier.auctionTierTypeId)
			{
				case Enumeration.AuctionTierTypes.MBPTier:
				case Enumeration.AuctionTierTypes.OriginalDealerTier:
					listItemPrice = auctionListItem.marketPrice
					break;
				case Enumeration.AuctionTierTypes.BiddingTier:
					listItemPrice = auctionListItem.buyNowPrice
					break;
			}
			return SiteService.priceDisplay(listItemPrice)
		}
	}

	return (
		<>
			<Modal
				size="lg"
				isOpen={ showMemberBuyNowModal }
				onOpened={ handleOnOpened }
				toggle={ handleCancelModal }
			>
				<SpinnerComponent
					loading={ isModalBusy }
					position="centered"
					color="#3578e5"
					secondaryColor="#f3f3f3"
					backgroundColor="#d3d3d3"
					spinnerType="circle-dots"
				/>
				<ModalHeader toggle={ handleCancelModal } charCode="Y">
					<div className="text-center text-muted mb-2">
						<small>{t('Modals.PlaceMemberBuyNow.Title')}</small>
					</div>
				</ModalHeader>
				<ModalBody>
					<Card className="border-0 mb-0">
						<CardBody className="px-lg-3 py-lg-3">
							<Card>
								{ (auctionListItem !== undefined) &&
									<CardBody>
										<Row className="align-items-center">
											<Col md="8" style={{ padding: '0' }}>
												<Row>
													<Col md="4">
														<img className="inspection-pic-sm" src={ auctionListItem.primaryDisplayImageUrl}  alt="..." width="127" height="95" />
													</Col>
													<Col md="8" className="text-primary">
														<div style={{ marginLeft: '5px' }}><label style={{ fontSize: '12px' }}>{auctionListItem.year + ' ' + auctionListItem.make + ' ' + auctionListItem.model}</label></div>
														<div style={{ marginLeft: '5px' }}><label style={{ fontSize: '12px' }}>{'Int: ' + auctionListItem.interiorColor + ' | ' + SiteService.numberDisplay(auctionListItem.cylinders, 0) + ' Cyl | ' + auctionListItem.displacement + ' | ' + auctionListItem.drivetrain + ' ' + auctionListItem.serialNumber}</label></div>
														<div style={{ marginLeft: '5px' }}>
															<img alt="..." style={{ display: 'inline-block', marginRight: '5px' }} height="24px" width="24px" src={ asDescribedImage } />
															<img alt="..." style={{ display: 'inline-block',marginRight: '5px'}} height="24px" width="24px" src={ conditionReportImage } />
															<img alt="..." style={{ display: 'inline-block', marginRight: '5px' }} height="24px" width="24px" src={ firstRunImage } />
														</div>
													</Col>
												</Row>
											</Col>
											<Col md="4" style={{ padding: '0' }}>
												<CardGroup style={{ minHeight:'140', height: '140' }}>
													<Card style={{ borderStyle: 'solid', borderWidth: '1px', backgroundColor: '#f6f9fc' }}>
														<CardBody style={{ padding: '12px' }}>
															<Col md="12" className="text-primary" >
																<div><label style={{ marginRight:'5px', fontSize: '12px' }}>{ t('Modals.PlaceMemberBuyNow.Highest_Bid') + ':' }</label><span style={{ fontSize: '12px' }}>{ SiteService.priceDisplay(auctionListItem.highestBidAmount) }</span></div>
																<div><label style={{ marginRight:'5px', fontSize: '12px' }}><span style={{ fontSize: '12px', marginRight: '5px' }}>{ SiteService.numberDisplay(auctionListItem.totalMembersWatching) }</span>{ t('Modals.PlaceMemberBid.Currently_Watching') }</label></div>
															</Col>
														</CardBody>
													</Card>
												</CardGroup>
											</Col>
										</Row>
									</CardBody>
								}
							</Card>
							{ (auctionListItem !== undefined) &&
								<Form role="form" style={{ marginTop: '10px' }}>
									<FormGroup className="row">
										<Label
											className="form-control-label"
											htmlFor="buyNowAmount"
											md="3"
										>
											{ t('Modals.PlaceMemberBuyNow.Buy_Now_Price') }
										</Label>
										<Col md="9">
											<Input
												autoFocus
												id="buyNowAmount"
												placeholder={ t('Modals.PlaceMemberBuyNow.Buy_Now_Price') }
												type="text"
												value={ buyNowPriceDisplay() }
												disabled={ true }
											/>
										</Col>
									</FormGroup>
								</Form>
							}
						</CardBody>
						<CardFooter>
							<Row style={{ width: '100%' }}>
								<Col md={6}>
									<Button
										block
										color="secondary"
										className="btn-block"
										onClick={ handleCancelModal }
										style={{ marginRight: '10px' }}
									>
										{ t('Modals.PlaceMemberBuyNow.Cancel') }
									</Button>
								</Col>
								<Col md={6}>
									{
										SiteService.isDealerBuyNowVisible(auctionListItem) &&
										<Button
											block
											color="primary"
											className="btn-block"
											onClick={() => setOpenConfirmBuyNow(true)}
										>
											{ t('Modals.PlaceMemberBuyNow.Place_Buy_Now') }
										</Button>
									}
								</Col>
							</Row>
						</CardFooter>
					</Card>
				</ModalBody>
			</Modal>

			<Modal
				isOpen={ openConfirmBuyNow }
				toggle={ () => setOpenConfirmBuyNow(false) }
			>
				<ModalHeader toggle={ () => setOpenConfirmBuyNow(false) } charCode="Y">
					{ t('Modals.PlaceMemberBuyNow.Title') }
				</ModalHeader>
				<ModalBody>
					<Card className="border-0 mb-0">
						<CardBody>
							<div className="modal-body"><p>Are you certain that you want to purchase this vehicle?</p></div>
						</CardBody>
						<CardFooter>
							<Row style={{ width: '100%' }}>
								<Col md={6}>
									<Button
										block
										color="secondary"
										type="button"
										className="btn-block"
										onClick={ () => setOpenConfirmBuyNow(false) }
									>
										{ t('Common.No') }
									</Button>
								</Col>
								<Col md={6}>
									<Button
										block
										color="primary"
										type="button"
										className="btn-block"
										onClick={(event) => { handlePlaceBuyNow(event) }}
									>
										{ t('Common.Yes') }
									</Button>
								</Col>
							</Row>
						</CardFooter>
					</Card>
				</ModalBody>
				<ModalFooter></ModalFooter>
			</Modal>
		</>
	)
}

export default PlaceMemberBuyNowModal
